// extracted by mini-css-extract-plugin
module.exports = {"panelBox":"index-module_panelBox_186Tf","arrow":"index-module_arrow_3AJE-","icon":"index-module_icon_2IVNA"};